import React, { Component } from "react";
import { Row, Col, FormControl } from "react-bootstrap";
import { Checkbox, Radio } from "react-icheck";
import PrintPreview from "./PrintPreview";
import PdfStore from "../../stores/PdfStore";
import moment from "moment";

class PrintTJYSalarySlipDoc extends Component {
  constructor(...args) {
    super(...args);

    const yTh = parseInt(moment().format("YYYY")) + 543;
    const curMonth = moment().format("MM");
    const curDay = moment().format("DD");
    const curH = moment().format("HH");
    const curM = moment().format("MM");

    this.state = {
      loading: false,
      data: [],
      loadingText: "กำลังดึงข้อมูล...",
      curDay: curDay,
      curMonth: curMonth,
      curYear: yTh,
      curH: curH,
      curM: curM,
      sumLate: 0,
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("portrait");
  }

  componentDidMount() {
    let { periodic, emType, em, ss } = this.props;
    let that = this;
    let { loadingText } = this.state;
    if (ss !== undefined && periodic === undefined && em === undefined) {
      PdfStore.loadSalarySlipDocByEm(ss, function (result) {
        if (result.data === undefined || result.data.length === 0)
          loadingText = "ไม่พบข้อมูล";

        that.setState({ data: result.data, loadingText: loadingText });
      });
    } else if (ss === undefined && periodic === undefined && em !== undefined) {
      PdfStore.loadSalarySlipDoc(em, function (result) {
        if (result.data === undefined || result.data.length === 0)
          loadingText = "ไม่พบข้อมูล";

        that.setState({ data: result.data, loadingText: loadingText });
      });
    } else {
      PdfStore.loadSalarySlipDoc(periodic, emType, function (result) {
        if (result.data === undefined || result.data.length === 0)
          loadingText = "ไม่พบข้อมูล";

        that.setState({ data: result.data, loadingText: loadingText });
      });
    }
  }


  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  renderIncome(income) {
    if (income === undefined || income.length === 0) {
      return (
        <tr>
          <td colSpan={3}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return income.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center font-print-slip-small">{index + 1}</td>
            <td className="font-print-slip-small">{item.detail}</td>
            <td className="text-right font-print-slip-small">
              {item.amount.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              })}
            </td>
          </tr>
        );
      });
    }
  }

  renderTimeRow(data, wMoment, item, index, keyIndex) {
    let { sumLate } = this.state;
    let hr_t_none = keyIndex > 1 ? "hr-t-none" : "";
    let d = item.display_work_date.substring(0, 2);
    let m = item.display_work_date.substring(3, 5);
    let y = item.display_work_date.substring(8, 10);
    let new_date = d + "/" + m + "/" + y;
    let new_start_time = item.start_time.substring(0, 5);
    let new_end_time = item.end_time.substring(0, 5);
    new_end_time = new_end_time === "00:00" ? "-" : new_end_time;

    let late_deduction = "",
      net_daily = "",
      early_deduction = "",
      dayType = "";
    if (item.work_late_minute * 1 > 0) {
      late_deduction =
        ((data.slip.daily_wage * item.work_late_minute) / 480).toFixed(0) * 1;
      dayType = "สาย";
    }
    if (item.end_early_minute * 1 > 0) {
      early_deduction =
        ((data.slip.daily_wage * item.end_early_minute) / 480).toFixed(0) * 1;
      if (item.work_late_minute * 1 > 0) {
        dayType = "สายและเลิกก่อน";
      } else {
        dayType = "เลิกก่อน";
      }
    }
    net_daily = data.slip.daily_wage - late_deduction * 1;
    let dow = wMoment.isoWeekday();
    if (dow === 7) {
      dayType = "วันอาทิตย์";
    }
    return (
      <tr key={keyIndex}>
        <td className={"text-center " + hr_t_none}>{keyIndex}</td>
        <td className={"text-center " + hr_t_none}>{new_date}</td>
        <td className={"text-center " + hr_t_none}>{new_start_time}</td>
        <td className={"text-center " + hr_t_none + " hr-l-none"}>
          {new_end_time}
        </td>
        <td className={"text-center " + hr_t_none}>
          {item.work_late_minute === "0" ? "" : item.work_late_minute}
        </td>
        <td className={"text-center " + hr_t_none}>
          {item.end_early_minute === "0" ? "" : item.end_early_minute}
        </td>
        <td className={"text-center " + hr_t_none}>{dayType}</td>
        <td className={hr_t_none}></td>
        <td className={hr_t_none + " hr-l-none"}></td>
        <td className={hr_t_none}></td>
        <td className={hr_t_none + " hr-l-none"}></td>
        <td className={hr_t_none}></td>
        <td className={"text-right " + hr_t_none}>
          {data.slip.daily_wage.toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })}
        </td>
        <td className={"text-right " + hr_t_none}>
          {late_deduction + early_deduction}
        </td>
        <td className={"text-right " + hr_t_none}>
          {net_daily.toLocaleString(undefined, { maximumFractionDigits: 2 })}
        </td>
      </tr>
    );
  }

  renderTimeEmptyRow(keyIndex, m,wage="") {


    let hr_t_none = keyIndex > 1 ? "hr-t-none" : "";

    let eraYear = (m.format("YYYY") * 1 + 543 + "").substring(2, 4);
    let dow = m.isoWeekday();

    return (
      <tr key={keyIndex}>
        <td className={"text-center " + hr_t_none}>{keyIndex}</td>
        <td className={"text-center " + hr_t_none}>
          {m.format("DD/MM/") + eraYear}
        </td>
        <td className={"text-center " + hr_t_none}>{""}</td>
        <td className={"text-center " + hr_t_none + " hr-l-none"}>{""}</td>
        <td className={"text-center " + hr_t_none}>{""}</td>
        <td className={"text-center " + hr_t_none}>{""}</td>
        <td className={"text-center " + hr_t_none}>
          {dow === 7 ? "วันอาทิตย์" : "ขาด"}
        </td>
        <td className={hr_t_none}></td>
        <td className={hr_t_none + " hr-l-none"}></td>
        <td className={hr_t_none}></td>
        <td className={hr_t_none + " hr-l-none"}></td>
        <td className={hr_t_none}></td>
        <td className={"text-right " + hr_t_none}>{dow===7?wage:""}</td>
        <td className={hr_t_none}></td>
        <td className={"text-right " + hr_t_none}>{dow===7?wage:""}</td>
      </tr>
    );
  }

  renderRowData(data) {
    let { employee } = data;
    let sundayWage = (employee.work_status === "0");

    if (data.time === undefined || data.time.length === 0) {
      return (
        <tr>
          <td colSpan={14}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      let curPeriodM = moment(data.start);
      let lastPeriodM = moment(data.end).add(1, "days");
      let timeContent = [];
      let keyIndex = 0;
      let absenceCount = 0;
      let workLateCount = 0;
      let minuteAmount = 0;
      let leaveEarlyCount = 0;
      let minuteLeaveEAmount = 0;
      let lateAmt = 0;
      let sundayCount = 0
      data.time.map((item, index) => {
        let wMoment = moment(item.work_date);
        let late_deduction = "",
          early_deduction = "";
        if (item.work_late_minute * 1 > 0) {
          late_deduction =
            ((data.slip.daily_wage * item.work_late_minute) / 480).toFixed(0) *
            1;
        }
        if (item.end_early_minute * 1 > 0) {
          early_deduction =
            ((data.slip.daily_wage * item.end_early_minute) / 480).toFixed(0) *
            1;
        }
        lateAmt += Number(late_deduction + early_deduction);
        if (wMoment.isSame(curPeriodM)) {
        } else {
          //Create more
          //console.log('not same',wMoment)
          //for (curPeriodM = moment(curPeriodM); curPeriodM.isBefore(wMoment); curPeriodM.add(1, 'days')) {
          while (curPeriodM.isBefore(wMoment)) {
            ++keyIndex;
            timeContent.push(this.renderTimeEmptyRow(keyIndex, curPeriodM,sundayWage?data.slip.daily_wage:""));

            let dow = curPeriodM.isoWeekday();
            if (dow !== 7) {
              absenceCount++;
            }
            if(dow===7 && sundayWage){
              sundayCount++;
            }
            
            curPeriodM = curPeriodM.add(1, "days");
            
          } //End for
        }

        if (item.work_late_minute * 1 > 0) {
          workLateCount++;
          minuteAmount += item.work_late_minute * 1;
        }
        if (item.end_early_minute * 1 > 0) {
          leaveEarlyCount++;
          minuteLeaveEAmount += item.end_early_minute * 1;
        }
        timeContent.push(
          this.renderTimeRow(data, wMoment, item, index, ++keyIndex)
        );
        curPeriodM = wMoment.add(1, "days");

        return item;
      });

      if (curPeriodM.isSame(lastPeriodM)) {
        //End
      } else {
        //Not Same
        while (curPeriodM.isBefore(lastPeriodM)) {
          ++keyIndex;
          timeContent.push(this.renderTimeEmptyRow(keyIndex, curPeriodM,sundayWage?data.slip.daily_wage:""));
          let dow = curPeriodM.isoWeekday();
          
          curPeriodM = curPeriodM.add(1, "days");
        }
      }

      let sum_daily = (data.slip.daily_wage * data.time.length)+(data.slip.daily_wage*sundayCount);
      let time_deduction_amt =
        (
          (data.slip.daily_wage * (minuteAmount + minuteLeaveEAmount)) /
          480
        ).toFixed(0) * 1;
      let net_daily = sum_daily - time_deduction_amt;
      timeContent.push(
        <tr style={{ display: data.time === undefined ? "none" : "" }}>
          <td className="hr-t-none hr-b-none" colSpan={9}></td>
          <td
            className="hr-t-none hr-b-none hr-l-none font-print-slip-small"
            colSpan={3}
          >
            รวม
          </td>
          <td className="hr-t-none hr-b-none hr-l-none text-right">
            {this.getNumberFormat(sum_daily)}
          </td>
          <td className="hr-t-none hr-b-none hr-l-none text-right">
            {this.getNumberFormat(lateAmt)}
          </td>
          <td className="hr-t-none hr-b-none hr-l-none text-right">
            {this.getNumberFormat(net_daily)}
          </td>
        </tr>
      );

      let absenceContent = data.absence.map((item, index) => (
        <div>
          {item.absence_name} วันที่ {item.display_start_date} จำนวน{" "}
          {item.duration} วัน
        </div>
      ));

      absenceCount = data.slip.count_office_work - data.time.length;
      const show_days_in_month = data.show_days_in_month?data.show_days_in_month:false
      if (workLateCount > 0 || absenceCount > 0 || leaveEarlyCount > 0) {
        timeContent.push(
          <tr>
            <td colSpan={15}>
              <div
                className="text-left summary-work"
                style={{ fontSize: "20px", marginTop: "10px" }}
              >
                <div>* สรุปการมาทำงาน</div>
                <div>
                  วันทำงาน {show_days_in_month?data.slip.days_in_month:data.slip.count_office_work} วัน มาทำงานจริง{" "}
                  {data.time.length} วัน {this.renderLeave(absenceCount)}
                </div>
                {absenceContent}
                <div>
                  {this.renderLate(workLateCount, minuteAmount)}{" "}
                  {this.renderEarly(leaveEarlyCount, minuteLeaveEAmount)}
                </div>
              </div>
            </td>
          </tr>
        );
      } else if (data.absence.length > 0) {
        timeContent.push(
          <tr>
            <td colSpan={14}>
              <div
                className="text-center summary-work"
                style={{ fontSize: "20px", marginTop: "10px" }}
              >
                <div>สรุปการมาทำงาน</div>
                {absenceContent}
              </div>
            </td>
          </tr>
        );
      }

      return timeContent;
    }
  }

  renderLeave(absenceCount) {
    if (absenceCount > 0) return <span>ขาดงาน {absenceCount} วัน</span>;
    else {
      return "";
    }
  }

  renderLate(workLateCount, minuteAmount) {
    if (workLateCount > 0)
      return (
        <span>
          มาสาย {workLateCount} ครั้ง รวม {minuteAmount} นาที
        </span>
      );
    else {
      return "";
    }
  }

  renderEarly(leaveEarlyCount, minuteLeaveEAmount) {
    if (leaveEarlyCount > 0)
      return (
        <span>
          เลิกก่อนเวลา {leaveEarlyCount} ครั้ง รวม {minuteLeaveEAmount} นาที
        </span>
      );
    else {
      return "";
    }
  }

  renderSalaryTitle(employee) {
    if (employee.work_status === "0") {
      return <span>เงินเดือน</span>;
    } else {
      return <span>รายได้ต่อวัน</span>;
    }
  }

  renderSalary(data) {
    let { employee, slip } = data;
    if (employee.work_status === "0") {
      //Monthy
      return (
        <span>
          {(slip.salary + "").toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })}
        </span>
      );
    } else {
      return (
        <span>
          {slip.daily_wage.toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })}
        </span>
      );
    }
  }

  renderLogoUrl(logoUrl) {
    let imgUrl = "";
    if (process.env.NODE_ENV == "development") {
      imgUrl = "https://demo2.bigfix.co/korat/pdf/" + logoUrl;
    } else {
      imgUrl = "../" + logoUrl;
    }
    return <img src={imgUrl} />;
  }

  renderSalary(data) {
    if (data.income.length > 0) {
      return (data.income[0].amount * 1).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
    } else {
      return "0";
    }

    //{(data.income.length>0?data.income[0].amount*1:'0').toLocaleString(undefined, {minimumFractionDigits: 2})}
  }

  renderComponentPage(index, data) {
    let { curDay, curMonth, curYear, curH, curM } = this.state;
    let currentDate = curDay + "/" + curMonth + "/" + curYear;
    let { company } = data;
    let title = "สลิปเงินเดือน";
    return (
      <div key={index} className="font-print">
        <div className="header-slip">
          <h2 className="text-right">{title}</h2>
          <article className={"article-company " + data.logo_class}>
            <div
              style={{
                width: data.logo_width + "px",
                textAlign: "center",
                lineHeight: "70px",
              }}
            >
              {this.renderLogoUrl(data.logo_url)}
            </div>
            <section
              className="font-20"
              style={{
                paddingTop:
                  data.logo_class == "bg-logo-absolute" ? "50px" : "0",
              }}
            >
              <strong>
                <p style={{ lineHeight: "0.7" }}>
                  {company.company_name} (สำนักงานใหญ่)
                </p>
                <p style={{ lineHeight: "0.7" }}>{company.company_addr} </p>
                <p style={{ lineHeight: "0.7" }}>
                  โทร {company.company_tel} โทรสาร {company.company_fax}
                </p>
              </strong>
            </section>
          </article>
          <div className="date-slip">
            <div>เวลา: {curH + ":" + curM}</div>
            <div>วันที่: {currentDate}</div>
          </div>
          <div style={{ borderBottom: "1px solid #111" }}>
            <table
              className="table table-slip-doc"
              style={{ marginBottom: "0" }}
            >
              <tbody>
                <tr>
                  <td className="font-print-slip-small">
                    {"รหัส-ชื่อ " + data.employee.employee_id}{" "}
                    {data.employee.first_name} {data.employee.last_name}
                  </td>
                  <td className="font-print-slip-small">
                    เลขที่อ้างอิง {data.slip.slip_no}
                  </td>
                  <td className="font-print-slip-small">
                    จากวันที่ {data.slip.period}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="font-18">
          <Row>
            <Col md={6} style={{ float: "left", width: "50%" }}>
              <div className="text-center font-print-slip">
                <u>รายการรับ</u>
              </div>
              <table className="table table-slip-doc">
                <tbody>
                  <tr>
                    <td className="font-print-slip text-left">
                      {this.renderSalaryTitle(data.employee)}
                    </td>
                    <td className="font-print-slip text-right">
                      {this.renderSalary(data)}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-print-slip text-left">วันทำงานจริง</td>
                    <td className="font-print-slip text-right">
                      {data.slip.count_actual_work}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-print-slip">
                      <u>รวมเงินเดือน</u>
                    </td>
                    <td className="font-print-slip text-right">
                      {this.renderSalary(data)}
                    </td>
                  </tr>
                  {data.income.map((item, index) => (
                    <tr
                      key={index}
                      style={{ display: index == 0 ? "none" : "" }}
                    >
                      <td className="font-print-slip text-left">
                        {item.detail}
                      </td>
                      <td className="font-print-slip text-right">
                        {(item.amount * 1).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="font-print-slip">รวมรับ</td>
                    <td className="font-print-slip text-right sum">
                      {data.summary.total_income.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col md={6} style={{ float: "right", width: "50%" }}>
              <div className="text-center font-print-slip">
                <u>รายการหัก</u>
              </div>
              <table className="table table-slip-doc">
                <tbody>
                  {data.deduction.map((item, index) => (
                    <tr key={index}>
                      <td className="font-print-slip">{item.detail}</td>
                      <td className="font-print-slip text-right">
                        {(item.amount * 1).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="font-print-slip">รวมหัก</td>
                    <td className="font-print-slip text-right">
                      {(data.summary.total_deduction * 1).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2 }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-print-slip">คงเหลือจ่ายจริง</td>
                    <td className="font-print-slip text-right sum">
                      {data.summary.net_income.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
          <Row>
            <Col
              md={4}
              style={{ float: "left", width: "35%", display: "none" }}
            >
              <table className="table table-slip-doc-sum">
                <tbody>
                  {this.renderIncome(data.income)}
                  <tr>
                    <td
                      colSpan={2}
                      className="text-center font-print-slip-small"
                    >
                      รวม
                    </td>
                    <td className="text-right font-print-slip-small">
                      {data.slip.drawing_money.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col md={12} style={{ float: "right", width: "100%" }}>
              <table className="table table-slip-list">
                <tbody>
                  <tr>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      ล/ค
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      วันที่
                    </td>
                    <td
                      colSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      ช่วงเช้า
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      สาย
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      เลิก
                      <br />
                      ก่อน
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      ประเภท
                    </td>
                    <td
                      colSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      อนุมัติโอที
                    </td>
                    <td
                      colSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      เวลา ชม.
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      โอที
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      ค่าแรง
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      หักสาย
                      <br />
                      เลิกก่อน
                    </td>
                    <td
                      rowSpan={2}
                      className="font-print-slip-small text-center hr-t-none"
                    >
                      สุทธิ
                    </td>
                  </tr>
                  <tr>
                    <td className="font-print-slip-small text-center">เข้า</td>
                    <td className="font-print-slip-small text-center">ออก</td>
                    <td className="font-print-slip-small text-center">ออก</td>
                    <td className="font-print-slip-small text-center">เข้า</td>
                    <td className="font-print-slip-small text-center">OT1</td>
                    <td className="font-print-slip-small text-center">OT2</td>
                  </tr>
                  {this.renderRowData(data)}
                </tbody>
              </table>
            </Col>
          </Row>
          <div className="footer-page">
            <table className="table table-slip-doc">
              <tbody>
                <tr>
                  <td className="text-center font-print-slip">
                    .....................................................
                    <br />
                    <br />
                    ผู้จ่าย
                  </td>
                  <td className="text-center font-print-slip">
                    .....................................................
                    <br />
                    <br />
                    ผู้รับเงิน
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  renderBlankPage() {
    return (
      <div className="font-print">
        <div className="font-30 text-center">{this.state.loadingText}</div>
      </div>
    );
  }

  render() {
    let { loading, data } = this.state;
    let { ss, periodic, emType } = this.props;
    let emTypeText =
      emType !== undefined ? (emType == 1 ? "รายเดือน" : "รายวัน") : "";
    if (data === undefined || data.length === 0) {
      return <PrintPreview>{this.renderBlankPage()}</PrintPreview>;
    } else {
      if (ss !== undefined) {
        return (
          <PrintPreview
            loading={loading}
            leftBarTitle={"สลิปเงินเดือน " + data.slip.slip_no}
          >
            {this.renderComponentPage(0, data)}
          </PrintPreview>
        );
      } else {
        return (
          <PrintPreview
            loading={loading}
            showPageNumber={false}
            leftBarTitle={
              "สลิปเงินเดือน ประจำงวด " + periodic + " ประเภท" + emTypeText
            }
          >
            {data.map((item, index) => {
              return this.renderComponentPage(index, item);
            })}
          </PrintPreview>
        );
      }
    }
  }
}

PrintTJYSalarySlipDoc.defaultProps = {
  title: "สลิปเงินเดือน",
  mode: "1",
  emType:"1"
};
export default PrintTJYSalarySlipDoc;



// WEBPACK FOOTER //
// ./src/view/print/PrintTJYSalarySlipDoc.js